import React from 'react';
import './index.scss';
import CategoryTable from './children/CategoryTable';
import { DEVELOPMENT_CONTENTS, STRENGTH_CONTENTS } from './constants';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';
import { EmptyState } from '../../../../../../../../Packages/EmptyState';

const KeyTakeAway = (props) => {
    const strengthsData = props.fetchTopStrengthAndTopDevApi.data != null && props.fetchTopStrengthAndTopDevApi.data.strengthsData ? props.fetchTopStrengthAndTopDevApi.data.strengthsData : []
    const developmentAreasData = props.fetchTopStrengthAndTopDevApi.data != null && props.fetchTopStrengthAndTopDevApi.data.developmentAreasData ? props.fetchTopStrengthAndTopDevApi.data.developmentAreasData : []
    return (
        <div className='cardwrapper'>
            <h3>Top 5 Strengths and Areas for Growth</h3>
            <p className='description-container'>The top 5 strengths and areas for growth are based the frequency with which the feedback providers voted a behavior among their top 3 priorities for the leader.</p>
            {
                props.fetchTopStrengthAndTopDevApi.isProcessing ? <GraphLoader height={300} width={600} /> :
                    (props.fetchTopStrengthAndTopDevApi.error && props.fetchTopStrengthAndTopDevApi.data === null) || (props.fetchTopStrengthAndTopDevApi.data != null && props.fetchTopStrengthAndTopDevApi.data.strengthsData && props.fetchTopStrengthAndTopDevApi.data.strengthsData.length === 0 && props.fetchTopStrengthAndTopDevApi.data.developmentAreasData && props.fetchTopStrengthAndTopDevApi.data.developmentAreasData.length === 0) ?
                        < EmptyState emptyStateMessage="No data found" /> :
                    <div className="keytakeaway-container">

                            {strengthsData.length != 0 && <CategoryTable data={strengthsData} contents={STRENGTH_CONTENTS} />}
                            {developmentAreasData.length != 0 && <CategoryTable data={developmentAreasData} contents={DEVELOPMENT_CONTENTS} />}


                    </div>}
        </div>
    );
};

export default KeyTakeAway;
